export default "__VITE_ASSET__CTKYsZoR__"